const Data = [
    {
        id: 1,
        category: "education",
        icon: "icon-graduation",
        year: "2019 - 2024",
        title: "Bachelor's Degree",
        sub: "Kansas State University",
        desc: "Developed a solid foundation in both software and hardware engineering, focusing on AI, machine learning, and embedded systems. Worked on various projects using multiple programming languages and technologies.",
    },
    {
        id: 2,
        category: "education",
        icon: "icon-graduation",
        year: "2023",
        title: "Senior Design Project",
        sub: "Kansas State University",
        desc: "Led a team to create a desktop arcade video game, handling game design, mechanics, and performance optimization. Achieved first place at the Senior Design Expo.",
    },
    {
        id: 3,
        category: "experience",
        icon: "icon-briefcase",
        year: "2023 - present",
        title: "Undergraduate Researcher",
        sub: "Laboratory for Knowledge Discovery in Databases",
        desc: "Worked on AI and machine learning projects, contributing to ongoing research and presenting findings at colloquiums. Developed and tested algorithms to improve performance.",
    },
    {
        id: 4,
        category: "experience",
        icon: "icon-briefcase",
        year: "2023 - 2024",
        title: "Teaching Assistant",
        sub: "Kansas State University",
        desc: "Helped teach introductory Python courses by assisting students, grading assignments, and holding office hour sessions to enhance their understanding.",
    },
];

export default Data